import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LoggerService } from 'src/app/services/logger.service';

@Component({
  selector: 'app-tamin-authoriz',
  templateUrl: './tamin-authoriz.component.html',
  styleUrls: ['./tamin-authoriz.component.css'],
})
export class TaminAuthorizComponent implements OnInit {
  constructor(
    private activatedRoute: ActivatedRoute,
    public logger: LoggerService
  ) {}

  ngOnInit(): void {
    const code = this.activatedRoute.snapshot.queryParams['code'];
    const expires_in = this.activatedRoute.snapshot.queryParams['expires_in'];
    localStorage.setItem('code', code);
    localStorage.setItem('expires_in', expires_in);

    this.activatedRoute.queryParamMap.subscribe((queryParam) => {
      if (code) {
        window.opener.postMessage({ code: code }, '*');
        window.close();
      }else{
        window.opener.postMessage({ errorMessage: `خطا در ایجاد ارتباط با سازمان تامین اجتماعی` }, '*');
      }
    });
  }
}
